module.exports = __webpack_public_path__ + "static/media/close_rightpanel.94b139f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/close_rightpanel.svg
// module id = 1397
// module chunks = 0